import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { FAQ_CONTENT, HOME } from '../content/site';
import { PageHeader } from '../components/blocks/PageHeader';
import { FaqAccordion } from '../components/blocks/FaqAccordion';
import { Section, Reveal, ButtonLink } from '../components/ui/Primitives';
export function FaqPage() {
  const {
    language
  } = useLanguage();
  const t = FAQ_CONTENT[language];
  const home = HOME[language];
  return <>
      <PageHeader eyebrow={t.eyebrow} title={t.title} sub={t.sub} data-id="element-245" data-mp="rddb9afg9vcl" />

      <Section tone="cream" data-id="element-246" data-mp="w8iv83pakzy1">
        <div className="mx-auto max-w-4xl" data-id="element-247" data-mp="wbwz5gdlth7l">
          <FaqAccordion data-id="element-248" data-mp="118x5lsed8lz8" />
          <Reveal delay={0.1} data-id="element-249" data-mp="119ony1iycn7k">
            <div className="mt-14" data-id="element-250" data-mp="117cc863sf92y">
              <ButtonLink to="/contact" data-id="element-251" data-mp="15b1ygowzpekt">{home.contactTeaser.cta}</ButtonLink>
            </div>
          </Reveal>
        </div>
      </Section>
    </>;
}